const estimatesTypes = {
  ESTIMATES_TABLE_STATE_SET: 'ESTIMATES/TABLE_STATE_SET',
  ESTIMATES_TABLE_STATE_RESET: 'ESTIMATES/TABLE_STATE_RESET',
};
export default estimatesTypes;
